import { GiftCreate } from 'components/product/gift-create/GiftCreate'
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useFetch } from 'services/useFetch'
import { API_GIFT } from 'services/apiGift'
import { convertErrorMessage, uploadFileToS3 } from 'utils/utils'
import { SUBMIT_TYPE } from 'constants/constant'
import { Alert } from 'avo-ui'
import { INITIAL_STATE, FIELD_NAME_DETAIL, GET_FIELD_NAME } from 'configs/product/configFormGift'

export const GiftCreateContainer = () => {
    const navigate = useNavigate()
    const [giftDetail, setGiftDetail] = useState(INITIAL_STATE)
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const [searchParams] = useSearchParams()
    const giftId = searchParams.get('giftId')
    const { fetching: getGiftDetail, isLoading } = useFetch(API_GIFT.DETAIL)
    const { fetching: getUrlGiftImages } = useFetch(API_GIFT.URL_GIFT_IMAGE)
    const { fetching: createGift, isLoading: isCreating } = useFetch(API_GIFT.CREATE)
    const { fetching: updateGift, isLoading: isUpdating } = useFetch(API_GIFT.UPDATE)
    const { fetching: draftGift, isLoading: isDrafting } = useFetch(API_GIFT.DRAFT)
    const [errorForm, setErrorForm] = useState({})
    const sectionRef = useRef()

    const onChangeForm = (e) => {
        const { name, value } = e
        setGiftDetail({ ...giftDetail, [name]: value })
    }

    const setShowAlert = (message) => {
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const setUploadGiftImage = async (type) => {
        try {
            const s3Urls = await getUrlGiftImages({ filename: giftDetail?.image_url?.name?.replace(/\s/g, '') })
            await uploadFileToS3(s3Urls?.data, giftDetail?.image_url?.file)
            onSave(type, `${s3Urls.data.url}${s3Urls.data.fields.key}`)
        } catch (err) {
            console.log('upload failed')
        }

        setIsLoadingUpload(false)
    }

    const validateForm = (type) => {
        return new Promise((resolve, reject) => {
            const errors = {}
            if (type === SUBMIT_TYPE?.PUBLISH) {
                Object.keys(giftDetail).forEach((key) => {
                    if (GET_FIELD_NAME[key] && !giftDetail[key]?.toString()) {
                        errors[key] = `${GET_FIELD_NAME[key]} wajib diisi`
                    }
                })
            } else if (type === SUBMIT_TYPE?.DRAFT && !giftDetail?.name) {
                errors['name'] = `${GET_FIELD_NAME['name']} wajib diisi`
            }
            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = (type) => {
        validateForm(type).then(async () => {
            if (giftDetail?.image_url?.name) {
                setIsLoadingUpload(true)
                await setUploadGiftImage(type)
            } else {
                onSave(type)
            }
        })
    }

    const onSave = (type, url = giftDetail?.image_url) => {
        const payload = {
            ...giftDetail,
            image_url: url,
        }

        if (!giftId && type === SUBMIT_TYPE?.PUBLISH) {
            createGift(payload)
                .then(() => {
                    setShowAlert('Gift Created !')
                    navigate('/product/gift-list')
                })
                .catch((error) => setErrorForm(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
        } else if (type === SUBMIT_TYPE?.PUBLISH) {
            updateGift(payload, giftId)
                .then(() => {
                    setShowAlert('Gift Updated !')
                    navigate('/product/gift-list')
                })
                .catch((error) => setErrorForm(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
        } else {
            draftGift(payload, giftId)
                .then(() => {
                    setShowAlert('Gift Drafted !')
                    navigate('/product/gift-list')
                })
                .catch((error) => setErrorForm(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
        }
    }

    useEffect(() => {
        sectionRef?.current?.scrollIntoView({ behavior: 'smooth' })
    }, [errorForm])

    useEffect(() => {
        if (giftId) {
            getGiftDetail({}, giftId).then((response) => setGiftDetail({ ...response?.data }))
        } else {
            setGiftDetail(INITIAL_STATE)
        }
        setErrorForm({})
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [giftId])

    const props = {
        sectionRef,
        giftDetail,
        onChangeForm,
        errorForm,
        isLoading,
        isLoadingUpload,
        isCreating,
        isUpdating,
        isDrafting,
        onSubmit,
    }

    return <GiftCreate {...props} />
}
